import axios from 'axios'

import EventHubMixin from '@/mixins/EventHub.js'

import config from '@/config/index.js'

const cache = {}

/**
 * Mixin
 */
export default {
    mixins:
    [
        EventHubMixin
    ],

    created()
    {

    },

    methods:
    {
        fetch(_path = '', _parameters = {}, callback = null, sync = false)
        {
            // Path
            const path = _path.replace(new RegExp('^/+'), '')

            // Parameters
            const defaultParameters = { lang: this.$route.meta.lang }
            const parameters = { ...defaultParameters, ..._parameters }
            const query = Object.keys(parameters).map((key) => `${key}=${parameters[key]}`).join('&')

            // Url
            const url = `${config.api.url}${config.api.path}${path}?${query}`

            // From cache
            if(typeof cache[url] !== 'undefined')
            {
                console.log(`%cAPI %c> %c${url} %c> %cfrom cache`, 'color: #bada55', '', 'color: #bada55', '', 'color: #bada55')

                if(typeof callback === 'function')
                {
                    // Content already loaded
                    // Trigger callback directly
                    if(cache[url].loaded)
                    {
                        callback(cache[url].content)
                    }
                    // Content not yet loaded
                    // Save callback for later call
                    else
                    {
                        cache[url].callbacks.push(callback)

                        // Loader
                        this.$eventHub.$emit('loader.add')
                    }
                }
            }

            // From api
            else
            {
                console.log(`%cAPI %c> %c${url} %c> %cfrom api`, 'color: #bada55', '', 'color: #bada55', '', 'color: #bada55')

                // Loader
                this.$eventHub.$emit('loader.add')

                // Save in cache
                cache[url] = {}
                cache[url].loaded = false
                cache[url].content = null
                cache[url].success = null
                cache[url].callbacks = []
                cache[url].callbacks.push(callback)

                // Create request
                const request = new XMLHttpRequest()

                // Request end callback
                const requestEndCallback = () =>
                {
                    const success = request.status === 200

                    // Success
                    if(success)
                    {
                        console.log(`%cAPI %c> %c${url} %c> %csuccess`, 'color: #bada55', '', 'color: #bada55', '', 'color: #74bff0')

                        try
                        {
                            cache[url].content = JSON.parse(request.responseText)
                        }
                        catch(error)
                        {
                            console.log(`%cAPI %c> %c${url} %c> %cerror`, 'color: #bada55', '', 'color: #bada55', '', 'color: #fd8182')
                            console.log(error)
                        }

                        cache[url].success = true
                    }

                    // Error
                    else
                    {
                        console.log(`%cAPI %c> %c${url} %c> %cerror`, 'color: #bada55', '', 'color: #bada55', '', 'color: #fd8182')

                        cache[url].success = false
                    }

                    cache[url].loaded = true

                    // Call every callback on this content
                    for(const _callback of cache[url].callbacks)
                    {
                        _callback(cache[url].content, success ? null : true)

                        // Loader
                        this.$eventHub.$emit('loader.remove')
                    }
                }

                // Async
                if(!sync)
                {
                    // Listen to ready state change
                    request.addEventListener('readystatechange', () =>
                    {
                        // Is done
                        if(request.readyState === XMLHttpRequest.DONE)
                        {
                            requestEndCallback()
                        }
                    })
                }

                // Send request
                request.open('GET', url, !sync)
                request.send(null)

                // Sync
                // Trigger end callback directly
                if(sync)
                {
                    requestEndCallback()
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/API.js